import { render, staticRenderFns } from "./comparison-categories.vue?vue&type=template&id=f1fdb8ca&scoped=true&"
import script from "./comparison-categories.vue?vue&type=script&lang=ts&"
export * from "./comparison-categories.vue?vue&type=script&lang=ts&"
import style0 from "./comparison-categories.vue?vue&type=style&index=0&id=f1fdb8ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fdb8ca",
  null
  
)

export default component.exports